<template>
  <pt-notice-form ref="form" class="pt-notice-form__withData" :isEdit="isEdit" :id="id" ></pt-notice-form>
</template>

<script>
import PtNoticeForm from './form'
export default {
  name: 'pt-notice-form__withData',
  components: {
    'pt-notice-form': PtNoticeForm
  },
  computed: {
    form () {
      return this.$refs.form
    }
  },
  props: {
    isEdit: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      default: ''
    }
  },
  methods: {
    submit () {
      this.form.validate().then(formValue => {
        this.$emit('submitLoad', true)
        this.$store.dispatch('publishNotice', formValue).then(data => {
          this.$emit('submitLoad', false)
          this.$message.success('发布消息成功')
          history.go(-1)
          // doing something ...
        }).catch(errorMessage => {
          this.$emit('submitLoad', false)
          console.error(errorMessage)
          this.$message.error(errorMessage)
        })
      })
    }
  }
}
</script>
